import React from 'react';
import ReactVivus from 'react-vivus';

import SEO from "../../common/SEO";


class ClockSvg extends React.Component {
     constructor() {
    super();
    this.state = { h: 0, m: 0, s: 0 };
    this.updateClock = this.updateClock.bind(this);
  }

  componentDidMount() {
    this.updateClock();
  }

 componentDidMount() {
    setInterval(() => {
      this.updateClock();
      
    }, 1000);
  }

  updateClock() {
    var now = Math.round((new Date().getTime() - new Date().setHours(0, 0, 0, 0)) / 1000);
    this.setState({ h: now / 720, m: now / 60, s: now });
  }

  render() {
    return /*#__PURE__*/(
    <div className="reloj">
                        <div className="clock">
                            <ClockHand name="hour" rotate={this.state.h} />
                            <ClockHands name="minute" rotate={this.state.m} />
                             
                            <ClockHandss name="second" rotate={this.state.s}/>
                             

                        </div>
                        <ReactVivus
                          id="poi"
                          option={{
                            file: './reloj.svg',
                            type: 'oneByOne',
                            animTimingFunction: 'EASE',
                            duration: 1250,
                            onReady: console.log
                         }}
                         callback={console.log}
                        />
                    </div>

);
  }
}
                          


class ClockHand extends React.Component {
  render() {
    var tf = { transform: `translateY(-50%) rotate(${this.props.rotate * 6}deg)` };
    return /*#__PURE__*/React.createElement("img", { className: `hour-hand hand ${this.props.name}`, src: `hor.svg` , style: tf });
  }
}
class ClockHands extends React.Component {
  render() {
    var tf = { transform: `translateY(-50%) rotate(${this.props.rotate * 6}deg)` };
    return /*#__PURE__*/React.createElement("img", { className: `minute-hand hand ${this.props.name}`,src: `min.svg`,  style: tf });
  }
}
class ClockHandss extends React.Component {
  render() {
    var tf = { transform: `translateY(-50%) rotate(${this.props.rotate * 6}deg)` };
    return /*#__PURE__*/React.createElement("img", { className: `second-hand hand ${this.props.name}`,  src: `sec.svg`, style: tf });
  }
}
export default ClockSvg;